import { render, staticRenderFns } from "./assignTaskView.vue?vue&type=template&id=7fc17220&scoped=true"
import script from "./assignTaskView.vue?vue&type=script&lang=js"
export * from "./assignTaskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc17220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc17220')) {
      api.createRecord('7fc17220', component.options)
    } else {
      api.reload('7fc17220', component.options)
    }
    module.hot.accept("./assignTaskView.vue?vue&type=template&id=7fc17220&scoped=true", function () {
      api.rerender('7fc17220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/tab4/assignTaskView.vue"
export default component.exports